// removed by extract-text-webpack-plugin
module.exports = {"cover-lots":"cover-lots___3IoAK","primary-img-container":"primary-img-container___26Z4E","primary":"primary___2lD-U","secondary-img-container":"secondary-img-container___Buijy","img-container":"img-container___26zUq","secondary":"secondary___3SuZ8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CoverLots/CoverLots.scss
// module id = i7yC
// module chunks = 57